
import { API_URL } from "../env";
const getFileUrl = (url: string) => {
    return API_URL + url;
}
export { getFileUrl }